import Image from "next/image";
import { cn } from "~/lib/utils";

/**
 * Tijana's illustrated portrait keeps an always-visible "AI" badge so her
 * identity as AI remains explicit everywhere the avatar appears.
 */
export function TijanaAvatar({
  size = 40,
  rounded = "full",
  className,
}: {
  size?: number;
  rounded?: "full" | "2xl";
  className?: string;
}) {
  return (
    <div
      className={cn("relative shrink-0", className)}
      style={{ width: size, height: size }}
    >
      <Image
        src="/images/tijana/tijana-avatar-illustrated.webp"
        alt="Tijana"
        width={size}
        height={size}
        className={cn(
          "h-full w-full object-cover",
          rounded === "full" ? "rounded-full" : "rounded-2xl",
        )}
      />
      <span className="bg-brand absolute -right-1 -bottom-1 rounded-full px-1 py-0.5 text-[10px] leading-none font-semibold text-white shadow-sm">
        AI
      </span>
    </div>
  );
}
